<template>
  <div>
        <b-card header="아레스: 라이즈 오브 가디언즈 런칭 이벤트">
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              게임명
            </div>
            <p>
              {{ creatorEvent.appName }}
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              이벤트 명
            </div>
            <p>
              {{ creatorEvent.name }}
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              이벤트 주소
            </div>
            <p>
              https://game.kakao.com/cr/{{creatorEvent.codeName}}  <b-link :href="`https://game.kakao.com/cr/${creatorEvent.codeName}`" target="_blank"> 링크확인 </b-link>
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              크리에이터 신청 기간
            </div>
            <p>
              {{ creatorEvent.creatorApplicableStartTime + ' - ' + creatorEvent.creatorApplicableEndTime }}
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              결제건 적립 기간
            </div>
            <p>
              {{ creatorEvent.paymentAccruedStartTime + ' - ' + creatorEvent.paymentAccruedEndTime }}
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              응원 기간
            </div>
            <p>
              {{ creatorEvent.donationStartTime + ' - ' + creatorEvent.donationEndTime }}
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              응원포인트 제한
            </div>
            <p>
              1회 최소: {{ commaStr(creatorEvent.donationMinAmount, "p") }} / 크리에이터 1인 최대: {{ commaStr(creatorEvent.creatorMaxAmount, "p") }}
            </p>
          </b-media>
          <b-media>
            <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
              정산 종료
            </div>
            <p>
              {{ creatorEvent.eventEndTime }}
            </p>
          </b-media>
          <b-row>
            <b-col class="col-auto">
              <router-link :to="{name:'CreatorPromotionEventList'}">
                <b-button>목록으로</b-button>
              </router-link>
            </b-col>
            <b-col class="text-right">
              <router-link :to="{name:'CreatorPromotionEventEdit'}">
                <b-button>등록정보수정</b-button>
              </router-link>
              <router-link class="ml-1" :to="{name:'CreatorPromotionMonitoringList', query:{eventId:eventId}}">
                <b-button>모니터링</b-button>
              </router-link>
              <router-link class="ml-1" :to="{name:'CreatorPromotionManageAlimtalkList', query:{eventId:eventId}}">
                <b-button>알림톡 발송관리</b-button>
              </router-link>
              <router-link class="ml-1" :to="{name:'CreatorPromotionZinnyLogList'}">
                <b-button>결제로그 추가</b-button>
              </router-link>
              <router-link class="ml-1" :to="{name:'CreatorPromotionZinnyLogTestList'}">
                <b-button>지니테스트 환경 관리 (결제/환불 로그 생성)</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>

        <b-card header="크리에이터 관리">
            <b-navbar>
                <b-nav pills>
                    <b-nav-item v-on:click="enrolledCreatorTypeFilterHandling(item)" :data-status=item.status :active="item.active" v-for="(item, index) in creatorType" :key="index"> <div v-if="item.code == 'APPROVED'">{{item.text+"("+approvedCreator.approvedCount+")"}}</div><div v-else>{{item.text+"("+(applyCreator.pendingCount + applyCreator.rejectedCount + approvedCreator.approvedCount + applyCreator.deletedCount)+")"}}</div></b-nav-item>
                </b-nav>
            </b-navbar>
            <ul>
            <div v-if="currentCreatorType.code == 'APPROVED'">
              <li v-for="str in accumulateInfo" v-bind:key="str">
                <div v-if="str=='등록된 전체 크리에이터'">
                  {{str}} {{approvedCreator.approvedCount}}명 / 자격해지된 크리에이터 {{approvedCreator.forbiddenCount}} 명
                </div>
                <div v-else-if="str=='전체 누적 응원포인트'">
                  {{str}} {{commaStr(approvedCreator.donationAmount, 'p')}}
                </div>
                <div v-else-if="str=='전체 누적 응원수'">
                  {{str}} {{commaStr(approvedCreator.donationCount, '회')}}
                </div>
                <div v-else>
                  {{str}} {{commaStr(approvedCreator.supporterCount, '명')}}
                </div>
              </li>
            </div>
            <div v-else>
              <li v-for="str in applyInfo" v-bind:key="str">

                <div v-if="str=='신청한 전체 크리에이터'">
                {{str}} {{commaStr(applyCreator.pendingCount + applyCreator.rejectedCount + approvedCreator.approvedCount + applyCreator.deletedCount,'명')}}
                </div>
                <div v-else-if="str=='심사중'">
                {{str}} {{commaStr(applyCreator.pendingCount,'명')}}
                </div>
                <div v-else>
                {{str}} {{commaStr(applyCreator.rejectedCount,'명')}}
                </div>
              </li>
            </div>
          </ul>
            <div v-if="currentCreatorType.code == 'APPROVED'">
              <b-navbar>
                <b-navbar-nav class="ml-auto">
                    <b-form-group
                            label="검색"
                            label-for="enrolledCreator"
                            label-cols="3"
                            horizontal>
                        <b-form-input id="enrolledCreator" type="text" autocomplete="enrolledCreator" placeholder="채널명 입력" v-model="approvedCreatorSearch"></b-form-input>
                    </b-form-group>
                </b-navbar-nav>
              </b-navbar>
              <b-table class="mt-3" hover striped bordered responsive :items="approvedCreator.list" :fields="approvedCreator.fields" :per-page="approvedCreator.perPage"
                :show-empty=true empty-text="리스트가 없습니다." id="approved-creator-table">
                <template slot="channelName" slot-scope="data">
                  {{data.item.channelName}}
                </template>
                <template slot="channelInfo" slot-scope="data">
                  {{data.item.supportCode}} /  <a :href="data.item.channelUrl" target="_blank">{{data.item.channelUrl}}</a> / {{data.item.viewInfo.channelIntro}}
                </template>
                <template slot="idpUserId" slot-scope="data">
                  {{data.item.cpAccount.idpUserId}}
                </template>
                <template slot="donationAmount" slot-scope="data">
                  {{commaStr(data.item.donationAmount, 'p')}} <br/><a :href="`${origin}/creatorPromotion/user/list?idpType=KAKAO&idpUserId=${data.item.cpAccount.idpUserId}&gameId=${creatorEvent.appId}&eventId=${creatorEvent.id}`" target="_blank"> 내역보기</a>
                </template>
                <template slot="donationCount" slot-scope="data">
                  {{commaStr(data.item.donationCount,'회')}}
                </template>
                <template slot="supporterCount" slot-scope="data">
                  {{commaStr(data.item.supporterCount,'명')}}
                </template>
                <template slot="approvedTime" slot-scope="data">
                  <div v-if="data.item.status == 'APPROVED' && data.item.approvedTime != null">
                    {{convertDate(data.item.approvedTime).format('YYYY.MM.DD HH:mm')}}
                  </div>
                </template>
                <template slot="statusName" slot-scope="data">
                  <div v-if="data.item.status == 'APPROVED'">
                    <b-link @click="showForbiddenModal(data.item.id, data.item.cpAccount.idpUserId)">크리에이터 자격해지</b-link>
                  </div>
                  <div v-else-if="data.item.status == 'FORBIDDEN'">
                    <b-link @click="openForbiddenDesc(data.item)">
                      제재 상세보기<br/>
                      <div v-if="data.item.userStatusLogDto != null">
                        {{convertDate(data.item.userStatusLogDto.createdAt).format('YYYY.MM.DD HH:mm')}}
                      </div>
                    </b-link>
                  </div>
                  <div v-else-if="data.item.status == 'DELETED'">
                    신청 취소<br/>
                    <div v-if="data.item.userStatusLogDto != null">
                      {{convertDate(data.item.userStatusLogDto.createdAt).format('YYYY.MM.DD HH:mm')}}
                    </div>
                  </div>
                </template>
                <template slot="recover" slot-scope="data">
                  <div v-if="data.item.status === 'FORBIDDEN'">
                    <b-link @click="showRecoverModal(data.item)">
                      [복구]
                    </b-link>
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
              </b-table>
              <nav>
                <b-pagination aria-controls="approved-creator-table" :total-rows="approvedCreator.totalElements" :per-page="approvedCreator.perPage" v-model="approvedCreatorCurrentPage" first-text="First" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
            <div v-else>
              <b-navbar>
                <b-navbar-nav class="ml-auto">
                    <b-form-group
                            label="검색"
                            label-for="enrolledCreator"
                            label-cols="3"
                            horizontal>
                        <b-form-input id="enrolledCreator" type="text" autocomplete="enrolledCreator" placeholder="채널명 입력" v-model="applyCreatorSearch"></b-form-input>
                    </b-form-group>
                </b-navbar-nav>
              </b-navbar>
              <b-table class="mt-3" hover striped bordered responsive :items="applyCreator.list" :fields="applyCreator.fields" :per-page="applyCreator.perPage"
                      :show-empty=true empty-text="리스트가 없습니다." id="apply-creator-table">
                <template slot="channelName" slot-scope="data">
                  {{data.item.channelName}}
                </template>
                <template slot="channelInfo" slot-scope="data">
                  {{data.item.supportCode}} /  <a :href="data.item.channelUrl" target="_blank">{{data.item.channelUrl}}</a> /  {{data.item.viewInfo.channelIntro}}
                </template>
                <template slot="idpUserId" slot-scope="data">
                  {{data.item.cpAccount.idpUserId}}
                </template>
                <template slot="createdAt" slot-scope="data">
                    {{convertDate(data.item.createdAt).format('YYYY.MM.DD HH:mm')}}
                </template>
                <template slot="statusName" slot-scope="data">
                  <div v-if="data.item.status == 'APPROVED'">
                    크리에이터 등록 완료<br/>
                    <div v-if="data.item.userStatusLogDto != null">
                      {{convertDate(data.item.userStatusLogDto.createdAt).format('YYYY.MM.DD HH:mm')}}
                    </div>
                  </div>
                  <div v-else-if="data.item.status == 'REJECTED'">
                      <b-link @click="openRejectedDesc(data.item)">
                        반려 상세보기<br/>
                        <div v-if="data.item.userStatusLogDto != null">
                          {{convertDate(data.item.userStatusLogDto.createdAt).format('YYYY.MM.DD HH:mm')}}
                        </div>
                      </b-link>
                  </div>
                  <div v-else-if="data.item.status == 'DELETED'">
                    신청 취소<br/>
                    <div v-if="data.item.userStatusLogDto != null">
                      {{convertDate(data.item.userStatusLogDto.createdAt).format('YYYY.MM.DD HH:mm')}}
                    </div>
                  </div>
                  <div v-else-if="data.item.status == 'FORBIDDEN'">
                    <b-link @click="openForbiddenDesc(data.item)">
                      제제 상세보기<br/>
                      <div v-if="data.item.userStatusLogDto != null">
                        {{convertDate(data.item.userStatusLogDto.createdAt).format('YYYY.MM.DD HH:mm')}}
                      </div>
                    </b-link>
                  </div>
                  <div v-else>
                    <b-link @click="showApprovedModal(data.item.id)">크리에이터 등록</b-link> |
                    <b-link @click="showRejectedModal(data.item.id, data.item.cpAccount.idpUserId)">반려</b-link>
                  </div>
                </template>
                <template slot="history" slot-scope="data">
                    <b-link @click="showHistoryModal(data.item.id, data.item.cpAccount.idpUserId)">신청 내역</b-link>
                </template>
              </b-table>
              <nav>
                <b-pagination aria-controls="apply-creator-table" :total-rows="applyCreator.totalElements" :per-page="applyCreator.perPage" v-model="applyCreatorCurrentPage" first-text="First" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
        </b-card>
        <b-modal v-model="forbiddenModal.isShow" ok-title="자격해지" cancel-title="닫기" centered id="forbidden-modal"  ref="btnShow" @ok="handleForbiddenOk">
            <div style="text-align: center; font-size: 20px;">
                <strong>크리에이터 자격을 해지하시겠습니까?</strong>
            </div>
            <br/>
            <b-form-group label="accountId" horizontal>
                <div>{{forbiddenModal.idpUserId}}</div>
            </b-form-group>
            <b-form-group label="사유" horizontal>
                <b-form-textarea
                    id="textarea"
                    v-model="forbiddenModal.description"
                    placeholder="입력하세요."
                    rows="3"
                    maxlength="50"
                    :state="validationLength(forbiddenModal.description.length, 50)"
                    max-rows="6" required>
                </b-form-textarea>
                <div style="text-align: right;">
                    {{forbiddenModal.description.length}}/50
                </div>
            </b-form-group>
            <div>
              <li>어드민의 [자격 해지]를 통해서 해지된 경우 해당 이벤트 종료 후 크리에이터 입력정보는 자동삭제처리됩니다.</li>
              <li>자격 해지는 오전 10시부터 오후 7시까지만 가능합니다.</li>
            </div>
        </b-modal>
        <b-modal  id="forbidden-second-modal" title="크리에이터 자격 해지" ok-only>
            <p class="my-2">크리에이터 자격 해지되었습니다.</p>
        </b-modal>
        <b-modal v-model="approvedModal.isShow" ok-title="등록" cancel-title="닫기" centered id="approved-modal"  ref="btnShow" @ok="handleApprovedOk">
            <div style="text-align: center; font-size: 20px;">
                <strong>크리에이터로 등록하시겠습니까?</strong>
            </div>
            <br/>
            <div>
              <li>해당 크리에이터에게 해지안내 알림톡이 발송됩니다.</li>
              <li>자격 해지는 오전 10시부터 7시까지만 가능합니다.</li>
            </div>
        </b-modal>
        <b-modal  id="approved-second-modal" title="크리에이터 등록" ok-only>
            <p class="my-2">크리에이터 등록되었습니다.</p>
            <div>
              <li>이후에는 전체 크리에이터 목록에서 확인하실 수 있습니다.</li>
            </div>
        </b-modal>
        <b-modal v-model="rejectedModal.isShow" ok-title="반려" cancel-title="닫기" centered id="rejected-modal"  ref="btnShow" @ok="handleRejectedOk">
            <div style="text-align: center; font-size: 20px;">
                <strong>크리에이터 심사에서 반려 처리하시겠습니까?</strong>
            </div>
            <br/>
            <b-form-group label="accountId" horizontal>
                <div>{{rejectedModal.idpUserId}}</div>
            </b-form-group>
            <b-form-group label="사유" horizontal>
                <b-form-textarea
                    id="textarea"
                    v-model="rejectedModal.description"
                    placeholder="입력하세요."
                    rows="3"
                    maxlength="50"
                    :state="validationLength(rejectedModal.description.length, 50)"
                    max-rows="6" required>
                </b-form-textarea>
                <div style="text-align: right;">
                    {{rejectedModal.description.length}}/50
                </div>
            </b-form-group>
            <div>
              <li>별도의 알림톡 발송은 없으며, 신청조회페이지에서 반려사유가 안내됩니다.</li>
              <li>반려의 경우 입력내용과 채널활동을 변경/추가하여 재신청가능합니다.</li>
            </div>
        </b-modal>
        <b-modal  id="rejected-second-modal" title="크리에이터 반려" ok-only>
            <p class="my-2">반려처리되었습니다.</p>
            <div>
              <li>별도의 알림톡 발송은 없으며, 신청조회페이지에서 반려사유가 안내됩니다.</li>
              <li>반려의 경우 입력내용과 채널활동을 변경/추가하여 재신청가능합니다.</li>
            </div>
        </b-modal>
        <b-modal v-model="isShowForbiddenDesc" title="제재 상세보기" ok-only>
            <b-form-group label="accountId" horizontal>
              <div>{{forbiddenDescCreator.idpUserId}}</div>
            </b-form-group>
            <b-form-group label="사유" horizontal>
              <div>{{forbiddenDescCreator.reason}}</div>
            </b-form-group>
        </b-modal>
        <b-modal v-model="isShowRejectedDesc" title="반려 상세보기" ok-only>
            <b-form-group label="accountId" horizontal>
              <div>{{rejectedDescCreator.idpUserId}}</div>
            </b-form-group>
            <b-form-group label="사유" horizontal>
              <div>{{rejectedDescCreator.reason}}</div>
            </b-form-group>
            <div>
              <li>별도의 알림톡 발송은 없으며, 신청조회페이지에서 반려사유가 안내됩니다.</li>
              <li>반려의 경우 입력내용과 채널활동을 변경/추가하여 재신청가능합니다.</li>
            </div>
        </b-modal>
        <b-modal v-model="history.isShowModal" title="크리에이터 신청 내역"  centered id="history-modal"  ref="btnShow">
            <b-media>
                <div slot="aside" class="columnWidth font-weight-bold" style="width: 200px; text-align: center;">
                    accountID
                </div>
                <p>
                    {{history.idpUserId}}
                </p>
            </b-media>
            <b-table hover striped bordered responsive="sm" :items="history.list" :fields="history.fields" :per-page="history.perPage" :sort-desc="true"
                     :show-empty=true empty-text="리스트가 없습니다." id="history-table">
                <template slot="createdAt" slot-scope="data">
                    <div v-if="data.item.createdAt != null">
                        {{convertDate(data.item.createdAt).format('MM/DD HH:mm')}}
                    </div>
                </template>
                <template slot="info" slot-scope="data">
                    <div v-if="data.item.info != null">
                        {{data.item.info.reason}}
                    </div>
                </template>
                <template slot="statusName" slot-scope="data">
                    <div v-if="data.item.status === 'FORBIDDEN'">
                        제재
                    </div>
                    <div v-else-if="data.item.status === 'REJECTED'">
                        반려
                    </div>
                    <div v-else-if="data.item.status === 'PENDING'">
                        신청
                    </div>
                    <div v-else-if="data.item.status === 'DELETED'">
                        신청 취소
                    </div>
                    <div v-else-if="data.item.status === 'APPROVED'">
                        등록
                    </div>
                </template>
            </b-table>
            <nav>
                <b-pagination aria-controls="history-table" :total-rows="history.totalElements" :per-page="history.perPage" v-model="historyCurrentPage" first-text="First" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
        </b-modal>
        <b-modal v-model="recoverModal.isShow" :ok-title="recoverModal.index === 0 ? '다음' : '복구' " cancel-title="닫기" centered id="recover-modal"  ref="btnShow"  @ok="handleRecoverOk">
          <div style="text-align: center; font-size: 20px;">
            <strong>크리에이터 자격을 복구하시겠습니까?</strong>
          </div>
          <br/>

          <hr/>
          <b-row>
            <b-col class="float-left">
              이용자
            </b-col>
            <b-col>
              <div>{{recoverModal.idpUserId}}</div>
            </b-col>
            <b-col></b-col>
            <b-col></b-col>
          </b-row>
          <hr/>
          <b-form-group label="사유" horizontal>
            <b-form-textarea
                id="textarea"
                v-model="recoverModal.description"
                placeholder="사유를 입력해주세요."
                rows="3"
                maxlength="50"
                :state="validationLength(recoverModal.description.length, 50)"
                max-rows="6" required>
            </b-form-textarea>
            <div style="text-align: right;">
              {{recoverModal.description.length}}/50
            </div>
          </b-form-group>
        </b-modal>
        <b-modal  id="recover-second-modal" ok-only>
          <p class="my-2">복구완료되었습니다.</p>
        </b-modal>
    </div>
</template>

<script>

    import creatorPromotionApi from '@/common/creatorPromotion/api/creatorPromotionApi'
    import { debounce } from 'lodash'
    import moment from 'moment'

    export default {
      name: "CreatorList",
      data() {
        return {
          origin: '',
          currentCreatorType : {
              text: "전체 크리에이터 목록",
              code: "APPROVED",
              searchType : 'APPROVED',
              active: true
          },
          accumulateInfo:[
            "등록된 전체 크리에이터",
            "전체 누적 응원포인트",
            "전체 누적 응원수",
            "전체 누적 서포터즈"
          ],
          applyInfo:[
            "신청한 전체 크리에이터",
            "심사중",
            "불합격"
          ],
          creatorType: [
            {
                text: "전체 크리에이터 목록",
                code: "APPROVED",
                searchType : 'APPROVED',
                active: true
            },
            {
                text: "신청 목록",
                code: "PENDING",
                searchType : 'PENDING',
                active: false
            }
          ],
          creatorEvent: {},
          approvedCreatorCurrentPage: 1,
          approvedCreatorSearch: '',
          approvedCreator : {
              list : [],
              perPage : 10,
              donationAmount: 0,
              donationCount: 0,
              supporterCount: 0,
              forbiddenCount: 0,
              approvedCount: 0,
              totalPages: 0,
              totalElements: 0,
              fields: [
                  {key: 'id', label: 'id', class: 'align-middle text-center'},
                  {key: 'channelName', label: '채널명', class: 'align-middle text-center'},
                  {key: 'channelInfo', label: '응원코드/채널주소/채널소개', class: 'align-middle text-center'},
                  {key: 'idpUserId', label: 'accountID', class: 'align-middle text-center'},
                  {key: 'donationAmount', label: '누적응원포인트', class: 'align-middle text-center'},
                  {key: 'donationCount', label: '누적응원수', class: 'align-middle text-center'},
                  {key: 'supporterCount', label: '서포터즈', class: 'align-middle text-center'},
                  {key: 'approvedTime', label: '크리에이터 등록일', class: 'align-middle text-center'},
                  {key: 'statusName', label: '관리', class: 'align-middle text-center'},
                  {key: 'recover', label: '복구', class: 'align-middle text-center'}
              ]
          },
          applyCreatorCurrentPage: 1,
          applyCreatorSearch: '',
          totalPages: 1,
          applyCreator : {
              list : [],
              perPage : 10,
              rejectedCount: 0,
              deletedCount: 0,
              pendingCount: 0,
              totalPages: 0,
              totalElements: 0,
              fields: [
                  {key: 'id', label: 'id', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  },
                  {key: 'channelName', label: '채널명', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  },
                  {key: 'channelInfo', label: '응원코드/채널주소/채널소개', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  },
                  {key: 'idpUserId', label: 'accountID', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  },
                  {key: 'createdAt', label: '신청일', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  },
                  {key: 'statusName', label: '관리', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  },
                  {key: 'history', label: '신청 내역', class: 'align-middle text-center',
                    tdClass: (value, key, item) => item.status === 'APPROVED' ? 'ApprovedTdColor' : ''
                  }
              ]
          },
          historyCurrentPage: 1,
          history: {
              isShowModal: false,
              creatorId: 0,
              idpUserId: 0,
              list: [],
              totalPages: 0,
              totalElements: 0,
              perPage : 10,
              fields: [
                  {key: 'createdAt', label: '날짜', class: 'align-middle text-center'},
                  {key: 'statusName', label: '구분', class: 'align-middle text-center'},
                  {key: 'info', label: '사유', class: 'align-middle text-center'},
              ]
          },
          forbiddenModal: {
            isShow: false,
            creatorId: '',
            idpUserId: '',
            description: '',
          },
          approvedModal: {
            isShow: false,
            creatorId: '',
          },
          rejectedModal: {
            isShow: false,
            creatorId: '',
            idpUserId: '',
            description: '',
          },
          recoverModal: {
            isShow: false,
            creatorId: '',
            idpUserId: '',
            description: '',
          },
          isShowRejectedDesc : false,
          isShowForbiddenDesc : false,
          rejectedDescCreator: {
            idpUserId: '',
            reason: ''
          },
          forbiddenDescCreator: {
            idpUserId: '',
            reason: ''
          }
        }
      },
      computed:{
        eventId(){
          return this.$router.currentRoute.params.id;
        }
      },
      methods: {
        async updateCreatorStatus(creatorId, requestBody) {

          const response = await creatorPromotionApi.updateCreatorStatus(creatorId, requestBody);

          if(response.status === 200 && response.data.apiResultCode === 200) {

            await this.reqCreatorStatusCount(this.eventId);

            if(this.currentCreatorType.code === "APPROVED") {
                await this.reqAccumulateCreatorInfo(this.eventId);
                await this.reqApprovedCreatorList(this.eventId, this.approvedCreatorSearch, this.approvedCreator.perPage, this.approvedCreatorCurrentPage - 1);
            } else {
                await this.reqApplyCreatorList(this.eventId, this.applyCreatorSearch, this.applyCreator.perPage, this.applyCreatorCurrentPage - 1);
            }
            return true;
          } else if(response.status === 200 && response.data.apiResultCode === 400) {
              alert(response.data.msg);
              return false;
          }

          return false;
        },
        async reqApprovedCreatorList(eventId, search, size, page) {
          const response = await creatorPromotionApi.getCreators(eventId, search, ['APPROVED', 'FORBIDDEN'], size, page);
          if(response.status === 200 && response.data.apiResultCode === 200) {
            const creatorList = response.data.data;
              this.approvedCreator.list = creatorList.content;
              this.approvedCreator.totalPages = creatorList.totalPages;
              this.approvedCreator.totalElements = creatorList.totalElements;

            return;
          }
        },
        async reqApplyCreatorList(eventId, search, size, page) {
            const response = await creatorPromotionApi.getApplyCreators(eventId, search, size, page);
            if(response.status === 200 && response.data.apiResultCode === 200) {
                const creatorList = response.data.data;
                this.applyCreator.list = creatorList.content;
                this.applyCreator.totalPages = creatorList.totalPages;
                this.applyCreator.totalElements = creatorList.totalElements;

                return;
            }
        },
        async reqCreatorEventList() {
            const response = await creatorPromotionApi.getCreatorEvent(this.eventId);
            if(response.status === 200 && response.data.apiResultCode === 200) {

              this.creatorEvent = response.data.data;

              await this.reqCreatorStatusCount(this.eventId);
              await this.reqAccumulateCreatorInfo(this.eventId);
              await this.reqApprovedCreatorList(this.eventId, null, this.approvedCreator.perPage, 0);
            }
        },
        async reqCreatorStatusCount(eventId) {
            const response = await creatorPromotionApi.getCreatorStatusCount(eventId);
            if(response.status === 200 && response.data.apiResultCode === 200) {
              const creatorStatusCount = response.data.data;
              this.applyCreator.rejectedCount = creatorStatusCount.rejectedCount;
              this.applyCreator.pendingCount = creatorStatusCount.pendingCount;
              this.applyCreator.deletedCount = creatorStatusCount.deletedCount;
              this.approvedCreator.approvedCount = creatorStatusCount.approvedCount;
              this.approvedCreator.forbiddenCount = creatorStatusCount.forbiddenCount;
            }
        },
        async reqAccumulateCreatorInfo(eventId) {
          const response = await creatorPromotionApi.getAccumulateCreatorInfo(eventId);
          if(response.status === 200 && response.data.apiResultCode === 200) {
            const accumulateInfo = response.data.data;
            this.approvedCreator.donationAmount = accumulateInfo.donationAmount == null ? 0 : accumulateInfo.donationAmount;
            this.approvedCreator.donationCount = accumulateInfo.donationCount;
            this.approvedCreator.supporterCount = accumulateInfo.supporterCount;
          }
        },
        enrolledCreatorTypeFilterHandling (clickedItem) {

            const clickedIndex = this.creatorType.indexOf(clickedItem)
            for (let item of this.creatorType) {
                item.active = false
            }

            this.creatorType[clickedIndex].active = true
            this.currentCreatorType = this.creatorType[clickedIndex]
            if(this.currentCreatorType.code === "APPROVED") {
              this.reqAccumulateCreatorInfo(this.eventId);
              this.reqCreatorStatusCount(this.eventId);
              this.reqApprovedCreatorList(this.eventId, this.approvedCreatorSearch, this.approvedCreator.perPage, 0);
            } else {
              this.reqApplyCreatorList(this.eventId, this.applyCreatorSearch, this.applyCreator.perPage, 0);
              this.reqCreatorStatusCount(this.eventId);
            }
        },
        convertDate(time) {
          return moment(time)
        },
        commaStr(val, str) {
          if(val == null)
            return "0"+str

          return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + str;
        },
        showForbiddenModal(creatorId, idpUserId) {
          this.forbiddenModal.creatorId = creatorId;
          this.forbiddenModal.idpUserId = idpUserId;
          this.forbiddenModal.description = '';
          this.forbiddenModal.isShow = true;
        },
        showApprovedModal(creatorId) {
          this.approvedModal.creatorId = creatorId;
          this.approvedModal.isShow = true;
        },
        showRejectedModal(creatorId, idpUserId) {
          this.rejectedModal.creatorId = creatorId;
          this.rejectedModal.idpUserId = idpUserId;
          this.rejectedModal.description = '';
          this.rejectedModal.isShow = true;
        },
        showHistoryModal(creatorId, idpUserId) {
            this.history.creatorId = creatorId;
            this.history.idpUserId = idpUserId;
            this.history.isShowModal = true;
            this.reqHistoryList(creatorId, this.history.perPage, 0);
        },
        showRecoverModal(item) {
          this.recoverModal.creatorId = item.id;
          this.recoverModal.idpUserId = item.cpAccount.idpUserId;
          this.recoverModal.description = '';

          this.recoverModal.isShow = true;
        },
        validationLength(length, maxLength) {
          return length > 0 && length <= maxLength;
        },
        async reqHistoryList(creatorId, size, page) {
            const response = await creatorPromotionApi.getCreatorHistoryList(this.eventId, creatorId, size, page);
            if(response.status === 200 && response.data.apiResultCode === 200) {
                const tempHistory = response.data.data;
                this.history.list = tempHistory.content;
                this.history.totalPages = tempHistory.totalPages;
                this.history.totalElements = tempHistory.totalElements;
                return;
            }

            this.history.list = [];
            this.history.totalPages = 0;
            this.history.totalElements = 0;
        },
        canWorkTime() {
          const hour = new Date().getHours();

          if(10 <= hour && hour < 19) {
            return true;
        }

        alert("오전 10시부터 오후 7시 사이에만 적용가능합니다.");
          return false;
        },
        async handleForbiddenOk(bvModalEvent) {
            bvModalEvent.preventDefault()

            if(!this.canWorkTime())
              return;

            if(this.forbiddenModal.description.length <= 0 || this.forbiddenModal.description.length > 50)
                return;

            const response = await this.updateCreatorStatus(this.forbiddenModal.creatorId, {
              eventId: this.eventId,
              idpUserId: this.forbiddenModal.idpUserId,
              eventCode: this.creatorEvent.codeName,
              creatorId: this.forbiddenModal.creatorId,
              description: this.forbiddenModal.description,
              status: "FORBIDDEN"
            });

            if(response === true) {
                this.$root.$emit('bv::hide::modal', 'forbidden-modal', '#btnShow');
                this.$root.$emit("bv::show::modal", "forbidden-second-modal");
            }

        },
        async handleApprovedOk(bvModalEvent) {
            bvModalEvent.preventDefault()

            if(!this.canWorkTime())
              return;

            const response = await this.updateCreatorStatus(this.approvedModal.creatorId, {
              eventId: this.eventId,
              eventCode: this.creatorEvent.codeName,
              creatorId: this.approvedModal.creatorId,
              status: "APPROVED"
            });

            if(response === true) {

                this.$root.$emit('bv::hide::modal', 'approved-modal', '#btnShow');
                this.$root.$emit("bv::show::modal", "approved-second-modal");
            }
        },
        async handleRejectedOk(bvModalEvent) {
            bvModalEvent.preventDefault()

            if(this.rejectedModal.description.length <= 0 || this.rejectedModal.description.length > 50)
                return;

            const response = await this.updateCreatorStatus(this.rejectedModal.creatorId, {
              eventId: this.eventId,
              idpUserId: this.rejectedModal.idpUserId,
              eventCode: this.creatorEvent.codeName,
              creatorId: this.rejectedModal.creatorId,
              description: this.rejectedModal.description,
              status: "REJECTED"
            });

            if(response === true) {

                this.$root.$emit('bv::hide::modal', 'rejected-modal', '#btnShow');
                this.$root.$emit("bv::show::modal", "rejected-second-modal");
            }

        },
        async handleRecoverOk(bvModalEvent) {
          bvModalEvent.preventDefault()

          if(this.recoverModal.description.length <= 0 || this.recoverModal.description.length > 50)
            return;

          const response = await this.updateCreatorStatus(this.recoverModal.creatorId, {
            eventId: this.eventId,
            idpUserId: this.recoverModal.idpUserId,
            eventCode: this.creatorEvent.codeName,
            creatorId: this.recoverModal.creatorId,
            description: this.recoverModal.description,
            status: "APPROVED"
          });

          if(response === true) {
            this.$root.$emit('bv::hide::modal', 'recover-modal', '#btnShow');
            this.$root.$emit("bv::show::modal", "recover-second-modal");
            this.initRecover();
          }
        },
        initRecover() {
          this.recoverModal.index = 0;
          this.recoverModal.creatorId = '';
          this.recoverModal.idpUserId = '';
          this.recoverModal.channelUrl = '';
          this.recoverModal.channelName = '';
          this.recoverModal.description = '';
          this.recoverModal.intro = '';
        },
        openForbiddenDesc(creator) {
          this.isShowForbiddenDesc = true;
          this.forbiddenDescCreator.idpUserId = creator.cpAccount.idpUserId;
          if(creator.userStatusLogDto != null && creator.userStatusLogDto.info != null)
            this.forbiddenDescCreator.reason = creator.userStatusLogDto.info.reason;
        },
        openRejectedDesc(creator) {
          this.isShowRejectedDesc = true;
          this.rejectedDescCreator.idpUserId = creator.cpAccount.idpUserId;
          if(creator.userStatusLogDto != null && creator.userStatusLogDto.info != null)
            this.rejectedDescCreator.reason = creator.userStatusLogDto.info.reason;

        }
      },
      async mounted() {
        this.origin = window.location.origin;
        await this.reqCreatorEventList();
      },
      watch: {
          approvedCreatorCurrentPage: function (pageNum) {
              this.reqApprovedCreatorList(this.eventId, this.approvedCreatorSearch,  this.approvedCreator.perPage,pageNum-1);
          },
          applyCreatorCurrentPage: function (pageNum) {
              this.reqApplyCreatorList(this.eventId, this.applyCreatorSearch,  this.applyCreator.perPage,pageNum-1);
          },
          historyCurrentPage: function (pageNum) {
              this.reqHistoryList(this.history.creatorId,  this.history.perPage,pageNum-1);
          },
          applyCreatorSearch: debounce(function(search) {
              this.reqApplyCreatorList(this.eventId, search, this.applyCreator.perPage, 0);
          }, 700),
          approvedCreatorSearch: debounce(function(search) {
              this.reqApprovedCreatorList(this.eventId, search, this.approvedCreator.perPage, 0);
          }, 700),
      },
    }

</script>

<style>
  .ApprovedTdColor {
    background-color: yellow;
  }
</style>
